import Vue from 'vue'
import Router from 'vue-router'
/* COMPONENTS */
import Home from '@/components/Home'
import RegistrationInvite from '@/components/RegistrationInvite'
import Register from '@/components/Register'
import ChangePassword from '@/components/ChangePassword'
import ForgotPassword from '@/components/ForgotPassword'
import Table from '@/components/Table'
import Categories from '@/components/Categories'
import Cart from '@/components/Cart'
import Login from '@/components/Login'
import Payment from '@/components/Payment'
import PaymentOfflineProcess from '@/components/PaymentOfflineProcess'
import PaymentProcess from '@/components/PaymentProcess'
import PaymentSuccess from '@/components/PaymentSuccess'
import EditCategories from '@/components/EditCategories'
import EditCategory from '@/components/EditCategory'
import AddCategory from '@/components/AddCategory'
import EditItems from '@/components/EditItems'
import EditItem from '@/components/EditItem'
import AddItem from '@/components/AddItem'
import AddFilterTag from '@/components/AddFilterTag'
import EditFilterTags from '@/components/EditFilterTags'
import EditFilterTag from '@/components/EditFilterTag'
import Orders from '@/components/Orders'
import Contact from '@/components/Contact'
import Legal from '@/components/Legal'
import TermsConditions from '@/components/TermsConditions'
import Privacy from '@/components/Privacy'
import Cookies from '@/components/Cookies'
import QRReader from '@/components/QRReader'
import StripeConnectStart from '@/components/StripeConnectStart'
import StripeConnectResponse from '@/components/StripeConnectResponse'
import StripeConnectInfo from '@/components/StripeConnectInfo'
// import PrinterLanguage from '@/components/PrinterLanguage'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'Home',
      path: '/',
      component: Home
    },
    {
      path: '/register/invite',
      name: 'RegistrationInvite',
      component: RegistrationInvite
    },
    {
      path: '/user/register/:randomstring',
      name: 'Register',
      component: Register,
      alias: '/register/:randomstring'
    },
    {
      path: '/user/changepassword',
      name: 'ChangePassword',
      component: ChangePassword
    },
    {
      path: '/user/forgotpassword',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/user/login',
      name: 'Login',
      component: Login,
      alias: '/login'
    },
    {
      path: '/menu',
      name: 'Categories',
      component: Categories
    },
    {
      path: '/menu/table/:table',
      name: 'Table',
      component: Table,
      props: true
    },
    {
      path: '/menu/edit/categories',
      name: 'EditCategories',
      component: EditCategories
    },
    {
      path: '/menu/edit/categories/:category',
      name: 'EditCategory',
      component: EditCategory,
      props: true
    },
    {
      path: '/menu/edit/category/add',
      name: 'AddCategory',
      component: AddCategory
    },
    {
      path: '/menu/edit/items',
      name: 'EditItems',
      component: EditItems
    },
    {
      path: '/menu/edit/items/:item',
      name: 'EditItem',
      component: EditItem,
      props: true
    },
    {
      path: '/menu/edit/items/add',
      name: 'AddItem',
      component: AddItem
    },
    {
      path: '/menu/edit/filtertags/add',
      name: 'AddFilterTag',
      component: AddFilterTag
    },
    {
      path: '/menu/edit/filtertags',
      name: 'EditFilterTags',
      component: EditFilterTags
    },
    {
      path: '/menu/edit/filtertags/:filtertag',
      name: 'EditFilterTag',
      component: EditFilterTag,
      props: true
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart
    },
    {
      path: '/payment',
      name: 'Payment',
      component: Payment
    },
    {
      path: '/payment/offline/process',
      name: 'PaymentOfflineProcess',
      component: PaymentOfflineProcess
    },
    {
      path: '/payment/process',
      name: 'PaymentProcess',
      component: PaymentProcess
    },
    {
      path: '/payment/success',
      name: 'PaymentSuccess',
      component: PaymentSuccess
    },
    {
      path: '/orders',
      name: 'Orders',
      component: Orders
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/legal',
      name: 'Legal',
      component: Legal
    },
    {
      path: '/legal/tc',
      name: 'TermsConditions',
      component: TermsConditions
    },
    {
      path: '/legal/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/legal/cookies',
      name: 'Cookies',
      component: Cookies
    },
    {
      path: '/qr/reader',
      name: 'QRReader',
      component: QRReader
    },
    {
      path: '/stripe/connect/start',
      name: 'StripeConnectStart',
      component: StripeConnectStart
    },
    {
      path: '/stripe/connect/response',
      name: 'StripeConnectResponse',
      component: StripeConnectResponse
    },
    {
      path: '/stripe/connect/info',
      name: 'StripeConnectInfo',
      component: StripeConnectInfo
    },
    /* {
      path: '/printer/lang',
      name: 'PrinterLanguage',
      component: PrinterLanguage
    }, */
    {
      path: '*',
      redirect: '/menu'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js